import { BaseController } from '../../../common/base/controller';

export class InputFormController extends BaseController {
  constructor(controllerService, FinanceTypes) {
    'ngInject';
    super({ controllerService, FinanceTypes });
  }

  $onInit() {
  }
}
